import { FieldConfig } from "../../../SetupFormGenerator/types";
import { DEFAULT_PAYMENT_SETTINGS_FIELDS } from "../DEFAULT/constants";

export enum TaxableBenefits {
  CAR = "Car",
  COMMUTER_ALLOWANCE = "Commuter allowance",
  EDUCATION = "Education",
  LIVING_ACCOMMODATION = "Living accommodations",
  LOANS = "Loans",
  MEAL_ALLOWANCE = "Meal Allowance",
  MEDICAL_INSURANCE = "Medical Insurance",
  MOVING = "Moving",
  NONCASH_GIFT_AND_AWARDS = "Non-cash gifts & awards",
  PHONE_AND_INTERNET = "Phone & internet",
  RECREATIONAL_FACILITIES_AND_DUES = "Recreational facilities & dues",
  REMOTE = "Remote work",
}

export const TAXABLEBENFITSVALUES = Object.values(TaxableBenefits);
export const TaxableBenefitsTypeMessage = null;

export const PAYMENT_SETTINGS_FIELDS: FieldConfig[] =
  DEFAULT_PAYMENT_SETTINGS_FIELDS;
